import React, { useState, useEffect, useRef } from 'react'
// import Card from '../../../CustomComponents/Card';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import { width } from "../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup';
import Loader from '../../../CustomComponents/Loader';
import CustomTextInput from '../../../CustomComponents/CustomtextInput';
import {
  GENERATE_EXISTING_PHONE_EMAIL_OTP,
  UPDATE_PHONE_NUMBER,
  GENERATE_UPDATE_EMAIL_OTP,
  GENERATE_UPDATE_ADDRESS_OTP,
  GET_USER_PROFILE_V2,
  GET_USER_PROFILE_LANGUGAGE_LIST,
  GET_USER_PROFILE_TIMEZONE_LIST,
  GENERATE_OTP_CHANGE_PIN, STATUS_SUCCESS_CODE,
  OTP_USERS, POST_UPDATE_USER_PROFILE,
  GOOGLE_PLACE_DETAILS_WITH_PLACE_ID,
  GOOGLE_PLACES_AUTO_COMPLETE,
  VERIFY_UPDATE_ADDRESS_OTP,
  SAVINGS_VALIDATE_SSN,
  CREATE_SAVINGS_ACCOUNT,
  GET_CARDHOLDER_CARDS,
  REGISTER_USER,
  CONTACT_US_URL,
  IDOLOGY_CAMEL_CASE,
  SMI_ONE_VALIDATE_SSN
} from '../../../../network/URLConstants';
import { GetApiHeadersWithBearer, PostRequest, GetRequest, GetApiHeadersWithOutBearer } from '../../../../network/NetworkUtils';
import { displayErrorMessage, displaySuccessMessage, parseGoogleLocationResponse, isEmailValid, validateMobileNumber, formatDateYYYYMMDD, LineBreaksSpan, addLineBreaks } from '../../../../utils';
import LineBreaks from '../../../../utils';
import { appTheme, retrieveData } from '../../../../helpers/utils/Utils'; 
import { set, useForm } from 'react-hook-form';
import { fetchConfigarationData } from '../../../../helpers/utils/Utils'; 
import { useLocation, useNavigate } from 'react-router-dom';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, geocodeByPlaceId } from 'react-places-autocomplete'; 
import HideSSNPic from '../../../../assets/images/hidepassword.png'
import { yupResolver } from '@hookform/resolvers/yup'; 
import pendingfile from '../../../../assets/images/pendingfile.png'
import profileError from '../../../../assets/images/profileError.png'
import Check from '../../../../assets/images/Check.png';
import logFirebaseEvents from '../../../LogFirebaseEvents'; 
import Card from '../../../CustomComponents/Card';
import FieldLabel from "../../../CustomComponents/FieldLabel";


const appConfigData = await fetchConfigarationData(); 

const SmiOneRegistrationThroughSSN = ({handleSmiOneSSN}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [isLoading, setIsLoading] = useState(false);
  const accessTokenToApi = useSelector(state => state.accessToken);
  const personalInfo = useSelector(state => state.signUpPersonelInfo);
  const signUpReferralCode = useSelector(state => state.signUpReferralCode);
  const signUpAccessCode = useSelector(state => state.signUpAccessCode);
  const ssnScreenThrough = useSelector(state => state.ssnScreenThrough);

  const savingsTermsConditions = useSelector(state => state.savingsTermsConditions);
  const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
  //universities
  const studentEmailAddress = useSelector(state => state.studentEmailAddress);
  const studentUniversityCode = useSelector(state => state.studentUniversityCode);
  const studentUniversityName = useSelector(state => state.studentUniversityName);
  const graduationDate = useSelector(state => state.graduationDate);

  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const selectedItem = cards?.[0]
  const userId = useSelector(state => state.userId);
  const [loading, setLoading] = useState(false)
  const [SSNBackupSecondary, setSSNBackupSecondary] = useState('')
  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
  const isSignUpKudzuplusTrueDataVal = useSelector(state => state.isSignUpKudzuplusTrueData);
  const signUpkudzuisTrialTrue = useSelector(state => state.isSignUpKudzuplusTrial);
   const isSignUpKudzuplusTrialVal = useSelector(state => state.isSignUpKudzuplusTrial);
  const welcomeCarouselSkipData = useSelector(state => state.welcomeCarouselSkipValue);
  const [smiOneErrMsg, setSmiOneErrMsg] = useState('');
  
  const appThemeData = appTheme(signUpkudzuPlusTrue);

  const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)]  cursor-pointer";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const HeaderMsgStylesplus = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-white";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-white";
  const HighlightMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-[#94C3E8]";
  const InputStyles = "font-hanken-grotesk   px-4 lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
  const SubHeadingStyles = "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
  const FailSubHeaderMsgStyles = "md:w-[317px] sm:w-[257px] font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";
  const summaryParagraphStyles =
    "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [subHeadingForCarousel, setSubHeadingForCarousel] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false) 
  const [isCursorVisible, setCursorVisibility] = useState(false);
  const [showSSN, setShowSSN] = useState(true);
  const ssnRef = React.createRef();
  const [SSNoError, setSSNoError] = useState('');
  const [ssnBackup, setSSnBackUp] = useState('');
  const [isSSNValid, setIsSSNValid] = useState(false);
  const [isSSNTouched, setIsSSNTouched] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [infoMessage, setinfoMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const checkbox1Ref = useRef(null);
  const button1Ref = useRef(null);
  const [isRegisterSucessModalOpen, setRegisterSucessModalModalOpen] = useState(false);
  const [cipStatus, setCipStatus] = useState('');
  const [isRegistered, setIsRegistered] = useState(false);
  const isB2c = useSelector(state => state.preferredIdentity); 
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const smiOneUserId = useSelector(state => state.smiOneKudzuResponseData.userId);
 

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    address: '',
    apt_etc: '',
    ssn_no: ''
  });
  const [ssn, setSSN] = useState('')





  useEffect(() => {
    handleSSNValue(ssnBackup)
  }, [showSSN])
  function formatValue(value) {
    const formattedValue = value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d{2})(\d{1,2})/, '$1 - $2 - $3');

    return formattedValue;
  }

  function formatSecuredValue(value) {
    const securedValue = value
      .replace(/[^0-9•]/g, '')
      .replace(/((?:\d|.){3})((?:\d|.){2})((?:\d|.){1,2})/, '$1 - $2 - $3')
      .replace(/[0-9]/g, '•');

    return securedValue;
  }
  const validationSchema = yup.object().shape({
    ssn_no: yup.string().required('Social Security Number (SSN) is required')
  });
 

 
 
  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
  }
 

  const finalApiHit = async (isKudzuplus) => { 
    const deviceId = await retrieveData('updatedDeviceId');
    let headers = await GetApiHeadersWithOutBearer(deviceId);
    setIsLoading(true); 

    const url = SMI_ONE_VALIDATE_SSN(smiOneUserId, appConfigData.CLIENT_ID )
    const objData ={
      "ssn": SSNBackupSecondary,
      "applicationId": appConfigData.CLIENT_ID
    }
   
    var response = await PostRequest(url , objData, headers);
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: responseObj.Response } });
      handleSmiOneSSN() 
      
    }  

    else {
     
      var arrMessages = responseObj.Messages;
      if (arrMessages.length > 0) {
        var messageObject = arrMessages[0];
        const message = messageObject.DisplayText;
        // const formattedMessage = "<span className='font-hanken-grotesk text-md leading-7 text-oops_error pr-2'>Oops! </span>" + message;
        // alert(message);
        setIsRegistered(true);
        setErrorMessage(message);
        setSmiOneErrMsg(messageObject.MessageOrField)
        setIsLoading(false);
      }
    }
  };

 

  const toggleCursor = () => {
    setCursorVisibility(!isCursorVisible);
  };
  const togglePasswordVisibility = () => {
    setShowSSN(!showSSN);
  };
  const { register, formState: { errors }, setError, setValue, clearErrors, getValues } = useForm({
    // mode: 'onTouched',
    resolver: yupResolver(validationSchema),
  });
  const handleSSNChange = (event) => {
    //debugger;
    clearErrors();
    const ssnNumber = event.target.value;
    // Remove all non-digit characters from the input
    const ssnNum = ssnNumber.replace(/[*-]/g, '').replace(/\D/g, '');
    // const ssnNum = ssnNumber.length != 9 ? ssnNumber.replace(/[*-]/g, '').replace(/\D/g, '') : ssnNumber;
    // const value = inputValue.replace(/\D/g, '')
    setSSnBackUp(ssnNum)
    handleSSNValue(ssnNum)
    clearErrors();
    setinfoMessage('');
    setIsSSNTouched(true)
    if (event.target.value.length < 10) { setSSNBackupSecondary(event.target.value.replace(' ', "").replace('-', "").replace(' ', ""))
      dispatch({ type: 'SMI_ONE_SSN_NUMBER', payload: { smiOneSSN : event.target.value.replace(' ', "").replace('-', "").replace(' ', "") } });
     }
    // Remove dashes from the input 
    if (ssnNum.length === 9) {
     
      clearErrors();
      setinfoMessage('');
      handleInputChange(event);
      setIsSSNValid(true)
      // validateSSN(ssnNum)
      // Update the form values
      // ValidateSSN(ssnNo, formValues); // Pass the SSN value and form values to the ValidateSSN function
    } else {
      setIsSSNValid(false)
    }
  };
  const handleInputChange = (event) => {
    clearErrors();
    setinfoMessage('');
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };
  function handleSSNValue(value) {
    const formatted = showSSN ? formatSecuredValue(value) : formatValue(value)
    setSSN(formatted)
  }

 
  const handleConfirm = () => {
    debugger;
    logFirebaseEvents("SSN_Screen", "Continue_Clicked", "Continue_Clicked", "", "");
    
    if(welcomeCarouselSkipData && isSignUpKudzuplusTrueDataVal){
    }
    else{
    if (ssnBackup == '' || !isSSNValid) {
      setError('ssn_no', { type: 'manual', message: 'Please enter valid SSN.' });
      setErrorMessage(t(''));
      return;
    }
    else if (isSSNValid) {
      finalApiHit()
 
    }
  }
    // else if () {}

  }
  const handlePaste = (event) => {
    event.preventDefault();
    return false;
  };
 
 
 
  return (
    <>
     <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
     <Card
        cardHeight={"auto"}
        isWhiteForSignup={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--modalcard-bg"}
        Cardcaption={addLineBreaks(t("SSN_For_SMI"))}
        header={true}
        footer={true}
        isForMobile={true}
        CardRadius={true}
        isLogo={isFromSmiOne ? true  : false}
        cardWidth ="w-[100%] md:w-[90%] lg:w-[70%] sm:w-[40%]"
      >
 
 
                <div className="flex flex-col md:w-[64%]"> 
                    <div className='flex flex-row w-full'>
                    <div className="sm:w-full md:w-4/5 lg:w-4/5 mt-[4rem] w-full"
                        onFocus={() => { toggleCursor() }}
                        onBlur={() => { toggleCursor() }}
                          >
                              <FieldLabel
                                  name="ssn_no"
                                  label={t('social_security_number')}
                                  required={true}
                              />
                        <div className="flex items-center relative">
                        <span
                            type="button"
                            className="text-gray-500 absolute right-4 top-5"
                            onClick={togglePasswordVisibility}
                        >
                            {showSSN ? <img src={appThemeData.Showpassword} className='w-[20px] h-[20px] cursor-pointer' alt={t('show_ssn_alt')} /> : <img src={HideSSNPic} className='w-[20px] h-[20px] cursor-pointer' alt={t('hide_ssn_alt')} />}
                        </span>
                            <input
                            name="ssn_no"
                            ref={ssnRef}
                            onPaste={handlePaste}
                            id={'ssn_no'}
                            {...register('ssn_no')}
                            value={SSNBackupSecondary}
                            placeholder={t('SSN_placeholder')}  
                            className={`${InputStyles} text-[var(--input-text1)]  bg-[var(--input-bg)] placeholder-[var(--input-text1)] ${showSSN ? 'password-input' : ''}`}
                            autoComplete="off"
                            autoFocus ="true"
                            onChange={handleSSNChange}
                            maxLength={9}
                            style={{ color: 'transparent', caretColor: 'transparent' }}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter') {
                                event.preventDefault();
                                handleConfirm()
                              }
                            }}

                        // value={ssn}
                        // onKeyUp={handleInputChange}
                        >
                        </input>
                        </div>
                        <div className='flex z-[999] opacity-100 relative top-[-51px] h-[60px] w-[80%] 
                bg-transparent items-center'

                        style={{ position: 'relative', top: -48 }}
                        onClick={() => {
                            const input = document.getElementById("ssn_no");
                            input.focus() 
                        }}>
                        <p className='h-[50px] no-underline ml-[15px] top-[10] text-[var(--input-text1)]' >{ssn}{isCursorVisible && <span style={{ display: 'inline-block', animation: isCursorVisible ? 'blink 0.8s step-end infinite' : 'none', verticalAlign: 'text-bottom', color: '#2965FB', fontWeight: '200', fontSize: '15px' }}>|</span>}</p>
                        </div>

                    </div>
                     
                    <style>{`@keyframes blink {0%, 100% {opacity: 1;}50% {opacity: 0;}}`}</style>
                    <div className="w-[10%] ml-4 flex items-center align-center">{(isSSNValid && isSSNTouched) && <img className='' src={Check} alt="Check" />}</div>
                    </div>

                        {errorMessage &&
                          <div className={`mt-[-2.5rem] mb-2 pb-[2rem]`}>
                            {displayErrorMessage(smiOneErrMsg === 'SSNNotMatched' ? t('ssn_not_matched') :  errorMessage)}
                          </div>
                        }

                    {/* {errors.ssn_no &&
                    <div className={` lg-mt-16 sm:-mt-32 md:-mt-16 mb-2 pb-[3rem]`}>
                        {displayErrorMessage(errors.ssn_no.message)}
                    </div>
                    } */}
                </div>
                <p className=' md:text-sm  text-[var(--modal-text-heading-clr)] sm:text-[12px] text-[14px] font-hanken-grotesk font-medium ' 
                     >{addLineBreaks(t("SSN_SMI_Footer"))}</p>
 
                <div className=' flex flex-row justify-end lg:mt-32 md:mt-32 sm:mt-6 sm:mx-0 mx-4 lg:mb-16 md:mb-16 mb-5'>
                  <button
                    type="button" 
                    ref={button1Ref} 
                    className={`font-hanken-grotesk sm:font-bold font-[600]
                                lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                 ${isSSNValid ? 'text-[var(--habit-add-clr)]' : 'text-[var(--ssn-disabled-continue)]'}
                                 cursor-pointer flex items-center`}
                    onClick={() => { handleConfirm() }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        handleConfirm()
                      }
                    }}
                  >
                    {t('continue')} 
                    <img
                      src={isSSNValid ? appThemeData.arrowWhiteTwofac : appThemeData.ArrowKudzuTo }
                      className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                      style={{opacity: signUpkudzuPlusTrue ? (isSSNValid ? 1 : 0.5 ) : '' }}
                      alt="" />
                  </button>
                </div> 

        </Card>
     </div>
     {isLoading && <Loader />}
    </>
  )
}

export default SmiOneRegistrationThroughSSN;
